// extracted by mini-css-extract-plugin
export default {"heading":"Users_heading__4h89O"};